export const Domain = process.env.REACT_APP_DOMAIN
// export const Domain = 'https://api.tcblbasketball.com/api/v1';
// export const Domain = 'https://apidev.tcblbasketball.com/api/v1';
export default Domain
